<template>
    <div class="main-content">
        <div class="loading-content" v-if="loading">
            <!-- Loading Animation 1 -->
            <!-- <div class="loading-center">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div> -->
            <!-- End Loading Animation 1 -->

            <!-- Loading Anition 2 -->
            <div class="loading-center"></div>
            <!-- End Loading Anition 2 -->

            <span>Loading..</span>
        </div>
        <img v-else src="/images/openimagehealth/example/content.png" />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true
            }
        }
    }
</script>